import $ from 'jquery';
import CurrencyConverter from 'shopify-currency-converter';

export default class StaticCart {
  constructor(section) {
    this.$el = $(section.el);
    this.events = [
      $('.cart-item-quantity-display', this.$el).on('click.cart', (event) => this.updateQuantity(event)),
      $('.cart-item-decrease', this.$el).on('click.cart', (event) => this.updateQuantity(event)),
      $('.cart-item-increase', this.$el).on('click.cart', (event) => this.updateQuantity(event)),
      $('.cart-instructions textarea', this.$el).on('change.cart', () => this.saveSpecialInstructions()),
      $('.dismiss', this.$el).on('click.cart', () => this.closeModal()),
      $('.cart-modal-wrapper.active', this.$el).on('click.cart', () => this.closeModal()),
      $('.get-rates', this.$el).on('click.cart', () => this.calculateShipping()),
    ];

    this.context = {};
    this.context.cart = JSON.parse($('[data-cart-strings]').text());
    this.context.shipping = null;

    this.$body = $(document.body);
    this.$modalWrapper = $('.cart-modal-wrapper', this.$el);
    this.$modalTitle = $('[data-modal-title]', this.$el);
    this.$modalMessage = $('[data-modal-message]', this.$el);
    this.$modalAction = $('[data-modal-action]', this.$el);

    this.$cartSubtotal = $('[data-cart-subtotal]', this.$el);
    this.$shippingCalculator = $('[data-shipping-calculator]');

    if (this.$shippingCalculator.length !== 0) {
      try {
        this.context.shipping = JSON.parse($('[data-shipping-calculator-strings]').text());
      } catch (error) {
        console.log('No shipping localisations found, unable to continue.');
      }

      if (this.context.shipping == null) {
        return;
      }

      if (this.context.shipping.customerCountry) {
        this.calculateShipping();
      }

      if ($('.cart-items').length) {
        this.shippingCalculator();
      }
    }

    Shopify.onError = (XMLHttpRequest) => {
      this.handleErrors(XMLHttpRequest);
    };
  }

  saveSpecialInstructions() {
    const newNote = $('.cart-instructions textarea').val();
    Shopify.updateCartNote(newNote, (cart) => {
      // empty function so that Shopify's callback isn't invoked
    });
  }

  updatePrice($el, price) {
    $el.html(price);

    if (Theme.enableCurrencyConverter) {
      CurrencyConverter.update($el[0]);
    }
  }

  removeProduct($productRow, cart) {
    $productRow.hide();
    this.updateCart(cart);
  }

  updateQuantity(event) {
    let newQuantity;
    const $target = $(event.currentTarget);
    const $productRow = $target.parents('tr');
    const $productPrice = $productRow.find('.cart-item-total .money');
    const $productQuantity = $productRow.find('.cart-item-quantity-display');
    let oldQuantity = parseInt($productQuantity.val(), 10);
    oldQuantity = Number.isNaN(oldQuantity) ? 1 : oldQuantity;
    const variant = $productRow.data('variant');

    if ($target.hasClass('cart-item-quantity-display')) {
      newQuantity = oldQuantity;
    } else if ($target.hasClass('cart-item-increase')) {
      newQuantity = oldQuantity + 1;
    } else if ($target.hasClass('cart-item-decrease')) {
      newQuantity = Math.max(oldQuantity - 1, 0);
    }

    $productQuantity.val(newQuantity);

    Shopify.changeItem(variant, newQuantity, (cart) => {
      const cartItems = cart.items;
      const cartItem = cartItems.filter(item => item.id === variant);

      if (!cartItems.length) { window.location = '/cart'; }
      if (newQuantity === 0) { this.removeProduct($productRow, cart); }

      const item = cartItem[0];
      const newProductPrice = Shopify.formatMoney(item.line_price, Theme.moneyFormat);
      const cartItemQuantity = item.quantity;
      this.updatePrice($productPrice, newProductPrice);
      $productQuantity.val(cartItemQuantity);

      if (cartItemQuantity !== newQuantity) {
        const message = this.context.cart.cartQuantityError.message
          .replace('** quantity **', cartItemQuantity)
          .replace('** title **', item.title);
        const { title } = this.context.cart.cartQuantityError;
        const action = this.context.cart.cartQuantityError.button;

        this.openModal(title, message, action);
      }

      this.updateCart(cart);
    });
  }

  updateCart(cart) {
    const newTotal = Shopify.formatMoney(cart.total_price, Theme.moneyFormat);
    this.updatePrice(this.$cartSubtotal, newTotal);
  }

  shippingCalculator() {
    Shopify.Cart.ShippingCalculator.show({
      submitButton: this.context.shipping.submitButton,
      submitButtonDisabled: this.context.shipping.submitButtonProcessing,
      customerIsLoggedIn: this.context.shipping.customerCountry,
      moneyFormat: Theme.moneyFormat,
    });

    const selectableOptions = this.$shippingCalculator.find('select');

    setTimeout(() => {
      selectableOptions.map(select => this.updateShippingLabel(select));
    }, 500);

    $('.cart-shipping-calculator select').change(() => {
      selectableOptions.map(select => this.updateShippingLabel(select));
    });
  }

  calculateShipping() {
    const rates = $('.get-rates').val(this.context.shipping.submitButtonProcessing);

    const shippingAddress = {};
    shippingAddress.zip = $('.address-zip').val() || '';
    shippingAddress.country = $('.address-country').val() || '';
    shippingAddress.province = $('.address-province').val() || '';

    Shopify.getCartShippingRatesForDestination(shippingAddress, () => {
      let address;
      let responseText;
      if (shippingAddress.zip.length) {
        address = shippingAddress.zip;
      }
      if (shippingAddress.province.length) {
        address = `${address}, ${shippingAddress.province}`;
      }
      if (shippingAddress.country.length) {
        address = `${address}, ${shippingAddress.country}`;
      }

      const shippingCalculatorResponse = $('.cart-shipping-calculator-response');
      shippingCalculatorResponse.empty().append("<p class='shipping-calculator-response message'/><ul class='shipping-rates'/>");

      const ratesFeedback = $('.shipping-calculator-response');

      if (rates.length > 1) {
        const firstRate = Shopify.Cart.ShippingCalculator.formatRate(rates[0].price);
        responseText = this.context.shipping.multiRates
          .replace('** address **', address)
          .replace('** number_of_rates **', rates.length)
          .replace('** rate **', `<span class='money'>${firstRate}</span>`);
        ratesFeedback.html(responseText);
      } else if (rates.length === 1) {
        responseText = this.context.shipping.oneRate
          .replace('** address **', address);
        ratesFeedback.html(responseText);
      } else {
        ratesFeedback.html(this.context.shipping.noRates);
      }

      rates.each((index, rate) => {
        const price = Shopify.Cart.ShippingCalculator.formatRate(rate.price);
        const rateValues = this.context.shipping.rateValues
          .replace('** rate_title **', rate.name)
          .replace('** rate **', `<span class='money'>${price}</span>`);

        $('.shipping-rates').append(`<li>${rateValues}</li>`);
      });

      $('.get-rates').val(this.context.shipping.submitButton);
    });
  }

  updateShippingLabel(value) {
    if (value) {
      const select = $(value);
      let selectedOption = select.find('option:selected').val();

      if (!selectedOption) {
        selectedOption = select.prev('.selected-text').data('default');
      }

      select.prev('.selected-text').text(selectedOption);

      setTimeout(() => {
        if (select.attr('name') === 'address[country]') {
          this.updateShippingLabel($('#address_province'));
        }
      }, 500);
    }
  }

  openModal(title, message, action) {
    this.$modalTitle.text(title);
    this.$modalMessage.text(message);
    this.$modalAction.text(action);
    this.$modalWrapper.addClass('active');
  }

  closeModal() {
    this.$modalWrapper.removeClass('active');
    this.$modalTitle.text('');
    this.$modalMessage.text('');
    this.$modalAction.text('');
  }

  handleErrors(errors) {
    const errorMessage = $.parseJSON(errors.responseText);

    if (errorMessage.zip || errorMessage.country) {
      let errorText = '';

      if (errorMessage.country) {
        errorText += `${this.context.shipping.countryErrorMessage.replace('** error_message **', errorMessage.country)}<br/>`;
      }

      if (errorMessage.zip) {
        errorText += this.context.shipping.zipErrorMessage.replace('** error_message **', errorMessage.zip);
      }

      $('.cart-shipping-calculator-response').html(`<p>${errorText}</p>`);
    } else {
      console.log('Error', errorMessage.stringify());
    }
  }

  onSectionUnload() {
    this.events.forEach($el => $el.off('.cart'));
  }
}
